export function LeaderboardViewModel(data) {

    var self = this;
    self.type = "LeaderboardViewModel";

    self.rootvm = data.rootvm;

    self.standings = ko.observableArray([]);
    self.year_standings = ko.observableArray([]);
    self.artist_recs = ko.observableArray([]);
    self.artist_invites = ko.observableArray([]);

    const today = new Date();
    self.month = ko.observable(today.getMonth() + 1);
    self.year = ko.observable(today.getFullYear());

    self.available_years = [];
    for (let y = 2023; y <= today.getFullYear(); y++) {
        self.available_years.push(y);
    }

    self.initialized = ko.observable(false);
    self.initialize = function(){
        if (!self.initialized()){
            self.lookup_current_leaders().then(function(){
                self.initialized(true);
            });
        }
    }

    self.lookup_current_leaders = function(){
        self.rootvm.is_busy(true);

        return $.ajax({
            url: self.rootvm.web_host + '/api/admin/leaderboard',
            type: 'GET',
            data: {
                month: self.month(),
                year: self.year()
            },
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                self.standings(data.standings);
                self.year_standings(data.year_standings);
                self.artist_recs(data.artist_recs);
                self.artist_invites(data.artist_invites);
            },
            error: function (data) {
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

    self.month.subscribe(self.lookup_current_leaders);
    self.year.subscribe(self.lookup_current_leaders);
};
